var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20657 18.7334C3.91356 19.0262 3.91356 19.5009 4.20657 19.7937C4.49958 20.0864 4.97464 20.0864 5.26764 19.7937L11.9998 13.0667L18.732 19.7937C19.025 20.0864 19.5 20.0864 19.793 19.7937C20.086 19.5009 20.086 19.0262 19.793 18.7334L13.0609 12.0065L19.793 5.27959C20.086 4.98681 20.086 4.51212 19.793 4.21934C19.5 3.92656 19.0249 3.92656 18.7319 4.21934L11.9998 10.9462L5.26766 4.21935C4.97465 3.92657 4.4996 3.92657 4.20659 4.21935C3.91358 4.51213 3.91358 4.98681 4.20659 5.27959L10.9387 12.0065L4.20657 18.7334Z",
    fill: "#040517"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEmail);
export default __webpack_public_path__ + "static/media/close-email.b6ec38c59671ed7f6579793fb327aad7.svg";
export { ForwardRef as ReactComponent };